<template>
    <footer>
        <div class="infos">
            <h1>INFORMATION</h1>
            <div><b>Phone:</b> <span>+86-574-89012968</span></div>
            <div><b>Fax:</b> <span>+86-574-87313473</span></div>
            <div><b>Email:</b> <span>info@globalwayhome.com</span></div>
            <div><b>Address:</b><br><span>1701 Hengdagao Mansion, 1016 South Qianhe Road, Shounan Street, Yinzhou District, Ningbo, Zhejiang Province, China</span></div>
            <p>
                Copyright 2021 Globalway Imp. & Exp. Co., Ltd . ALL RIGHT RESERVED
                <a href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备2021021565号-2</a>
            </p>
        </div>
        <div class="wechat">
            <img src="../../public/img/wechat.png" alt="wechat">
        </div>
    </footer>
</template>

<script>
export default {
    
}
</script>

<style lang="less" scoped>
    footer { position: relative; background-color: #373b47; color: #FFF; font-size: 1rem; width: 100%; overflow: hidden; }
    .infos { margin: 1rem .7rem; }
    .infos > * { margin-bottom: .6rem; }
    .infos h1 { font-weight: 400; font-size: 1.1rem; }
    .infos span { color: #DDD; font-size: .8rem; }
    .infos p { font-size: .8rem; margin-bottom: 0; padding-top: .3rem; border-top: 1px solid #DDD; }
    .infos p a:link { color: #FFF; }
    .infos p a:visited { color: #FFF; }
    .infos p a:hover { color: #FFF; }
    .infos p a:active { color: #FFF; }
    .wechat { text-align: center; position: absolute; right: .7rem; top: 1rem; }
    .wechat img { width: 6rem; object-fit: contain; }
</style>